// extracted by mini-css-extract-plugin
export default {"root":"wvY2iYedcoTQ9DCf4RZl","trash":"d4mnDNTfXiY3W9WCgkch","left":"cg7_WGiIz4XUXHp0yQnr","number":"GI7Ea4t928X2MPjDSua3","textarea":"SVZWAII6zFRbAfLA0_WP"};